export default __webpack_public_path__ + "static/HouseWithCoins-d1eb77b27f07b6ecc2cb1922b50c7c94.svg";